module.exports = __webpack_public_path__ + "static/media/score-crown.e67ba3d1.svg";